import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import rem from "./utils/rem";

function _isMobile() {
    let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return flag;
};
if (_isMobile()) {
    rem();
} else {

};

import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
}).$mount('#app')